import { FC } from "react";

import { useTranslate } from "./useTranslate";
import { TranslationKey } from "./translator";

interface Props {
  textKey: TranslationKey;
  params?: Record<string, string | number | undefined | null>;
  children?: (text: string) => string;
  allowHtml?: boolean;
  concat?: string;
}

const Translated: FC<Props> = ({
  textKey,
  params,
  children,
  allowHtml,
  concat,
}) => {
  const translate = useTranslate();

  let text = children
    ? children(translate(textKey, params))
    : translate(textKey, params);

  if (concat) {
    text = text.concat(concat);
  }

  return allowHtml ? (
    <span dangerouslySetInnerHTML={{ __html: text }} />
  ) : (
    <>{text}</>
  );
};

export default Translated;
